/**
 * Labstep
 *
 * @module components/Organization/UserManager
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { DefaultSort } from 'labstep-web/components/Entity/Table/SortOptions/utils';
import { ShareLinkInvitationActionCreateOrganization } from 'labstep-web/components/ShareLinkInvitation/Action/Create/Organization';
import { ShareLinkInvitationModalViewPendingInvites } from 'labstep-web/components/ShareLinkInvitation/Modal/ViewPendingInvites';
import UserOrganizationTable from 'labstep-web/components/UserOrganization/Table';
import { Filter } from 'labstep-web/constants/filters';
import { UserOrganization } from 'labstep-web/models/user-organization.model';
import type React from 'react';
import type { IUserOrganizationManagerProps } from './types';

export const UserOrganizationManager: React.FC<
  IUserOrganizationManagerProps
> = ({ organization }) => {
  return (
    <EntitySearch
      searchKey="search_query"
      entityName={UserOrganization.entityName}
      params={{
        organization_id: organization.id,
      }}
      bulkActions={[
        BulkAction.add_to_workspace,
        BulkAction.update_organization_role,
        BulkAction.disable_users,
      ]}
      sortOptions={{
        user_first_name: {
          label: 'First Name',
          default_sort: DefaultSort.asc,
        },
        user_last_name: {
          label: 'Last Name',
          default_sort: DefaultSort.asc,
        },
      }}
      filters={[Filter.is_user_deleted]}
      action={() => (
        <ShareLinkInvitationActionCreateOrganization
          organization={organization}
        />
      )}
    >
      {({ entities }) => (
        <div>
          {!organization.is_saml_enabled &&
            organization.logged_user_user_organization.type ===
              'admin' && (
              <ShareLinkInvitationModalViewPendingInvites
                entity={organization}
              />
            )}
          <UserOrganizationTable userOrganizations={entities} />
        </div>
      )}
    </EntitySearch>
  );
};
